import { getEndPoint, select } from '@udecode/plate'
import { EditorEntityData } from '../../../helpers/EditorEntityData'
import type { BufferEditor } from '../../../BufferEditor/types.plate'
import { insertLinkedInMention } from '../transforms/insertLinkedInAnnotation'

// Serves as the `textToNodes` callback for the linkedin-annotation plugin.
// It uses the linkedin mention entities stored and provided to convert
// the text at the given indices to linkedin mention elements.
export const findAndInsertLinkedInAnnotations = (
  editor: BufferEditor,
  { entities }: { entities?: EditorEntityData } = {},
): void => {
  if (entities) {
    EditorEntityData.getLinkedInAnnotations(entities).forEach(
      (linkedInMention) => {
        insertLinkedInMention(editor, linkedInMention)
      },
    )

    // Move selection to end of editor content
    const editorEndPoint = getEndPoint(editor, [])
    select(editor, {
      anchor: editorEndPoint,
      focus: editorEndPoint,
    })
  }
}
